var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg14233754871582967215(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e79bd;}.cls-2{fill:#2d3e50;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "b") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.46864,
    y: 87.56501,
    width: 8.64107,
    height: 12.82345
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.46864,
    y: 64.43378,
    width: 8.64107,
    height: 12.82344
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.74496,
    y: 55.82613,
    width: 11.81934,
    height: 12.82344
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.74496,
    y: 32.69487,
    width: 11.81934,
    height: 12.82344
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.74496,
    y: 79.20617,
    width: 14.96463,
    height: 26.72666
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 103.89029,
    y: 87.56501,
    width: 8.64107,
    height: 12.82345
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 103.89029,
    y: 64.43378,
    width: 8.64107,
    height: 12.82344
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 69.4357,
    y: 55.82613,
    width: 11.81934,
    height: 12.82344
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 69.4357,
    y: 32.69487,
    width: 11.81934,
    height: 12.82344
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 66.29042,
    y: 79.20617,
    width: 14.96463,
    height: 26.72666
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.24545,43.74789v-24.027L64,4.9124,31.75455,19.72093v24.027H1.784V123.0876H126.216V43.74789Zm-64.4909,71.28673H7.82378v-65.247H31.75455Zm58.45117,0H37.79428V23.59307L64,11.55835,90.20572,23.59307Zm29.9705,0H96.24545v-65.247h23.93077Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg14233754871582967215);
export default __webpack_public_path__ + "static/media/14233754871582967215.40fb6459.svg";
export { ForwardRef as ReactComponent };